var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useCallback, useEffect, useState } from "react";
import { Container, DropOuter, Label, DropMainText, DropSubText, UploadIcon, FileList, FileListItem, FileListText, PreviewImg, PreviewContainer, OverlayContainer, IconBtn, IconCloseBtn, PreviewError, Button, } from "./FileUpload.styles";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/" + pdfjs.version + "/pdf.worker.min.js";
import { useDropzone } from "react-dropzone";
import uploadIcon from "../assets/FileUpload/upload.svg";
import eyeIcon from "../assets/FileUpload/eye on.svg";
import trashIcon from "../assets/FileUpload/trash can.svg";
import closeIcon from "../assets/FileUpload/close.svg";
import { useField, useFormikContext } from "formik";
export var PreviewFile = function (_a) {
    var previewFile = _a.previewFile, setPreviewFile = _a.setPreviewFile, name = _a.name;
    var _b = __read(useState(0), 2), numPages = _b[0], setNumPages = _b[1];
    var _c = __read(useState(0), 2), rotate = _c[0], setRotate = _c[1];
    var renderPreview = function (previewFile) {
        if (previewFile.type.startsWith("image/")) {
            return React.createElement(PreviewImg, { src: URL.createObjectURL(previewFile) });
        }
        if (previewFile.type === "application/pdf") {
            return (React.createElement(Document, { file: previewFile, onLoadSuccess: function (_a) {
                    var numPages = _a.numPages;
                    return setNumPages(numPages);
                } }, Array.apply(null, Array(numPages))
                .map(function (_, i) { return i + 1; })
                .map(function (page) { return (React.createElement(Page, { key: page, pageNumber: page, rotate: rotate })); })));
        }
        return React.createElement(PreviewError, null, "File does not have a preview.");
    };
    var overlayClickHandler = function (e) {
        var target = e.target;
        if (target.id === name + "-overlay") {
            setPreviewFile(undefined);
        }
    };
    return (React.createElement(React.Fragment, null, previewFile ? (React.createElement(OverlayContainer, { id: name + "-overlay", onClick: overlayClickHandler },
        React.createElement("div", null,
            previewFile.type === "application/pdf" ? (React.createElement(Button, { onClick: function () { return setRotate(function (rot) { return (rot + 90) % 360; }); }, type: "button" }, "Rotate")) : null,
            React.createElement(PreviewContainer, null,
                React.createElement(IconCloseBtn, { src: closeIcon, onClick: function () { return setPreviewFile(undefined); } }),
                renderPreview(previewFile))))) : null));
};
export var FileUpload = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, allowedFileTypes = _a.allowedFileTypes, setFieldValue = _a.setFieldValue, maxNumberOfFiles = _a.maxNumberOfFiles, _c = _a.hideAtMax, hideAtMax = _c === void 0 ? false : _c, 
    //minNumberOfFiles,
    props = __rest(_a, ["label", "allowedFileTypes", "setFieldValue", "maxNumberOfFiles", "hideAtMax"]);
    var _d = __read(!setFieldValue ? useField(props) : [props], 1), field = _d[0];
    if (!setFieldValue)
        setFieldValue = useFormikContext().setFieldValue;
    var _e = __read(useState(new Map()), 2), uploadedFiles = _e[0], setUploadedFiles = _e[1];
    var _f = __read(useState([]), 2), fileNameArray = _f[0], setFileNameArray = _f[1];
    var _g = __read(useState(), 2), previewFile = _g[0], setPreviewFile = _g[1];
    useEffect(function () {
        if (field.value) {
            setUploadedFiles(field.value);
            setData(field.value);
        }
    }, [field.value]);
    var setData = function (data) {
        setFileNameArray(Array.from(data.keys()));
        if (setFieldValue)
            setFieldValue(field.name, data);
    };
    var fileDeleteClickHandler = function (fileName) {
        if (previewFile && previewFile.name === fileName) {
            setPreviewFile(undefined);
        }
        var newFiles = new Map(uploadedFiles);
        newFiles.delete(fileName);
        setUploadedFiles(newFiles);
        setData(newFiles);
    };
    var filePreviewClickHandler = function (fileName) {
        if (previewFile && previewFile.name === fileName) {
            setPreviewFile(undefined);
        }
        else {
            var file = uploadedFiles.get(fileName);
            setPreviewFile(file);
        }
    };
    var onDrop = useCallback(function (acceptedFiles) {
        var e_1, _a;
        try {
            for (var acceptedFiles_1 = __values(acceptedFiles), acceptedFiles_1_1 = acceptedFiles_1.next(); !acceptedFiles_1_1.done; acceptedFiles_1_1 = acceptedFiles_1.next()) {
                var file = acceptedFiles_1_1.value;
                if (maxNumberOfFiles && uploadedFiles.size >= maxNumberOfFiles) {
                    //if there is only one max file replace the file
                    if (maxNumberOfFiles === 1) {
                        var files = new Map().set(file.name, file);
                        setUploadedFiles(files);
                        setData(files);
                    }
                    break;
                }
                var newFiles = new Map(uploadedFiles);
                newFiles.set(file.name, file);
                setUploadedFiles(newFiles);
                setData(newFiles);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (acceptedFiles_1_1 && !acceptedFiles_1_1.done && (_a = acceptedFiles_1.return)) _a.call(acceptedFiles_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }, []);
    var _h = useDropzone({
        onDrop: onDrop,
        accept: allowedFileTypes,
        maxFiles: maxNumberOfFiles,
    }), fileRejections = _h.fileRejections, getRootProps = _h.getRootProps, getInputProps = _h.getInputProps, isDragActive = _h.isDragActive;
    var uploadId = props.id || "FileUpload-" + label.replace(/\s+/g, "").trim();
    var rejectedFileList = fileRejections.map(function (reject) { return (React.createElement(FileListItem, { key: reject.file.name },
        reject.file.name,
        React.createElement(FileList, null, reject.errors.map(function (e) { return (React.createElement(FileListItem, { key: e.code }, e.message)); })))); });
    return (React.createElement(Container, null,
        label !== "" ? React.createElement(Label, null, label) : null,
        React.createElement(FileList, null, fileNameArray.map(function (name) { return (React.createElement(FileListItem, { key: name },
            React.createElement(IconBtn, { src: eyeIcon, onClick: function () { return filePreviewClickHandler(name); } }),
            React.createElement(FileListText, null, name),
            React.createElement(IconBtn, { src: trashIcon, onClick: function () { return fileDeleteClickHandler(name); } }))); })),
        React.createElement(FileList, null, rejectedFileList),
        React.createElement(PreviewFile, { previewFile: previewFile, setPreviewFile: setPreviewFile, name: field.name }),
        !(hideAtMax &&
            maxNumberOfFiles &&
            uploadedFiles.size >= maxNumberOfFiles) && (React.createElement(DropOuter, __assign({ id: uploadId }, getRootProps()),
            React.createElement(UploadIcon, { src: uploadIcon }),
            React.createElement("input", __assign({}, getInputProps())),
            React.createElement(DropMainText, null, "Click to upload"),
            React.createElement(DropSubText, null, isDragActive ? "Drop file here" : "Or, drag and drop a file here")))));
};
//# sourceMappingURL=FileUpload.js.map